import { render, staticRenderFns } from "./PackageServiceIcon.vue?vue&type=template&id=0e71e9c2&"
import script from "./PackageServiceIcon.vue?vue&type=script&lang=ts&"
export * from "./PackageServiceIcon.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports